var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnouncmentIcon = function SvgAnnouncmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 230,
    height: 154,
    fill: "none",
    viewBox: "0 0 216 154"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#announcmentIcon_svg__a)",
    d: "M45 38.076V154H30.532V22.031C30.533 9.871 16.87 0 0 0h8.289C37.445 0 45 17.045 45 38.076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#announcmentIcon_svg__b)",
    d: "M0 0h170.259v144H0z",
    transform: "matrix(-1 0 0 1 215.259 0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "announcmentIcon_svg__a",
    x1: 9,
    x2: -28.386,
    y1: 206.5,
    y2: -33.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711211"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "announcmentIcon_svg__b",
    width: 10,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.00113 .00134)"
  })))));
};
export default SvgAnnouncmentIcon;